export function getPromptGlobalUses(prompt) {
  return Number(prompt?.uses ?? prompt?.stats?.usageCount ?? prompt?.stats?.usage ?? prompt?.usage ?? 0) || 0;
}

export function getPromptGlobalFavorites(prompt) {
  return Number(prompt?.favorites ?? prompt?.stats?.favorites ?? 0) || 0;
}

export function getPromptGlobalLikes(prompt) {
  return Number(prompt?.likes ?? prompt?.stats?.likes ?? 0) || 0;
}
